import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { actionToCreateQna } from "../../actions/qnaActions";
import LoadingBoxWithoutText from "../../modules/shared/components/LoadingBoxWithoutText";
import MessageBox from "../../modules/shared/components/MessageBox";
import { firstNamePicker, lastNamePicker } from "../../libraries/ercLibrary";
import QnaPrivacy from "./QnaPrivacy";
import "./QnaUserForm.css";

// MAKE SURE PHONE NUMBER STARTS WITH 5
function normalizePhoneNumber(value) {
  return value.replace(value[0] !== "5" && value[0], "");
}

export default function QnaUserForm(props) {
  const dispatch = useDispatch();

  // PROPS CMING FROM QnaScreen AND ProductLanding AND ProductReviewsScreen
  const { authenticatedUser, productId, productName } = props;

  // REDUX STATE THAT HOLDS THE CREATED QNA INFO
  const createQna = useSelector((state) => state.createQna);
  const { loading, error, success } = createQna;

  // BRING METHODS FROM "useForm"
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  //MEASURE TO CHECK IF TEXT AREA MAX LENGTH HAS BEEN REACHED
  const [question, setQuestion] = useState("");
  const [remainingSpace, setRemainingSpace] = useState(0);
  const [maxReachedAlert, setMaxReachedAlert] = useState("");
  useEffect(() => {
    if (question.length === 1000) {
      setMaxReachedAlert("Maksimum sayıya ulaştınız");
    } else if (question.length < 1000) {
      setMaxReachedAlert("");
    }
    setRemainingSpace(1000 - question.length);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question]);

  // DISPLAY PRIVACY TERMS
  const [privacyTerms, setPrivacyTerms] = useState(false);

  // NAME AND PHONE TO DISPLAY ON QnaPrivacy
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  // FORM SUBMIT
  function onSubmit(data) {
    if (maxReachedAlert) {
      return "";
    }

    // PREPARATION TO CREATE A QUESTION
    const date = new Date();
    const dateFormat = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()} , ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
    const firstName = firstNamePicker(data.name);
    const lastName = lastNamePicker(data.name);
    let dataPhone = data.phone.replace(/\D/g, "");
    dataPhone = dataPhone.substr(dataPhone.length - 10);

    dispatch(
      actionToCreateQna({
        firstName,
        lastName,
        phone: dataPhone,
        question: data.question,
        questionTime: dateFormat,
        userId: authenticatedUser ? authenticatedUser._id : "",
        productId,
        productName,
      })
    );
  }

  return (
    <>
      {privacyTerms && (
        <p
          className="fs125 txtcenter green pointer"
          onClick={() => setPrivacyTerms(false)}
        >
          Geri Git
        </p>
      )}
      {!privacyTerms ? (
        <form className="qna-form" onSubmit={handleSubmit(onSubmit)}>
          {!success && (
            <>
              <p>Sorunuzu şimdi gönderin. Bir SMS ile yanıtımızı ileteceğiz.</p>
              <div className="qna-form-border-div">
                <div
                  className={
                    !errors.name
                      ? "qna-form-div1"
                      : "qna-form-div1 qna-form-alert-background"
                  }
                >
                  <div className="qna-form-icon-holder-div">
                    <i
                      title="Ad Soyad"
                      className={
                        !errors.name
                          ? "fas fa-user qna-form-user-icon"
                          : "fas fa-user qna-form-user-icon qna-form-error"
                      }
                    ></i>
                  </div>
                  <input
                    type="text"
                    inputMode="text"
                    autoComplete="name"
                    placeholder="Ad Soyad"
                    name="name"
                    id="name"
                    defaultValue={
                      authenticatedUser &&
                      authenticatedUser.firstName +
                        " " +
                        authenticatedUser.lastName
                    }
                    {...register("name", {
                      required: { value: true, message: "İsim giriniz" },
                      minLength: { value: 3, message: "İsim eksik" },
                      validate: (value) =>
                        /.\s./.test(value) || <p>Soyad giriniz</p>,
                    })}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <label htmlFor="name">
                    {errors.name && (
                      <div className="qna-form-errorText qna-form-error">
                        {errors.name.message}
                      </div>
                    )}
                  </label>
                </div>
                <div
                  className={
                    !errors.phone
                      ? "qna-form-div2"
                      : "qna-form-div2 qna-form-alert-background"
                  }
                >
                  <div className="qna-form-icon-holder-div">
                    <i
                      title="Cep telefonu"
                      className={
                        !errors.phone
                          ? "fas fa-mobile-alt qna-form-phone-icon"
                          : "fas fa-mobile-alt qna-form-phone-icon qna-form-error"
                      }
                    ></i>
                  </div>
                  <input
                    type="tel"
                    inputMode="numeric"
                    autoComplete="tel-area-code"
                    name="phone"
                    id="phone"
                    placeholder="Cep telefonu - 5 ile başlayınız"
                    defaultValue={authenticatedUser && authenticatedUser.phone}
                    {...register("phone", {
                      required: {
                        value: true,
                        message: "Cep telefonu giriniz",
                      },
                      minLength: { value: 10, message: "Cep numarası kısa" },
                    })}
                    onChange={(e) => {
                      const { value } = e.target;
                      e.target.value = normalizePhoneNumber(value);
                      setPhone(e.target.value);
                    }}
                    onKeyDown={(e) => {
                      const backspacePressed = e.key !== "Backspace";
                      const tab = e.key === "Tab";
                      const arrowRight = e.key === "ArrowRight";
                      const arrowLeft = e.key === "ArrowLeft";
                      const arrowUp = e.key === "ArrowUp";
                      const arrowDown = e.key === "ArrowDown";
                      const space = e.key === " ";
                      const backSlash = e.key === "/";

                      //const number = /[0-9]+/.test(e.key);

                      const currentValue = e.currentTarget.value;
                      if (
                        backspacePressed &&
                        !tab &&
                        !arrowRight &&
                        !arrowLeft &&
                        !space &&
                        !arrowUp &&
                        !arrowDown
                      ) {
                        const lengthNoSpaces = currentValue.length;
                        if (lengthNoSpaces === 13) {
                          setValue(
                            "phone",
                            currentValue.substr(0, currentValue.length - 1),
                            {}
                          );
                        }
                        if (lengthNoSpaces === 3 && !backSlash) {
                          setValue("phone", currentValue + " ", {});
                        }
                        if (lengthNoSpaces === 7 && !backSlash) {
                          setValue("phone", currentValue + " ", {});
                        }
                        if (lengthNoSpaces === 10 && !backSlash) {
                          setValue("phone", currentValue + " ", {});
                        } else if (lengthNoSpaces === 2 && backSlash) {
                          setValue("phone", currentValue + "", {});
                        }
                      } else {
                        if (currentValue[currentValue.length - 2] === "") {
                          setValue(
                            "phone",
                            currentValue.substr(0, currentValue.length - 1)
                          );
                        }
                      }
                    }}
                  />
                  <label htmlFor="phone">
                    {errors.phone && (
                      <div className="qna-form-errorText qna-form-error">
                        {errors.phone.message}
                      </div>
                    )}
                  </label>
                </div>
                <div
                  className={
                    !errors.address
                      ? "qna-form-div5"
                      : "qna-form-div5 qna-form-alert-background"
                  }
                >
                  <textarea
                    type="text"
                    inputMode="text"
                    autoComplete="off"
                    name="question"
                    id="question"
                    placeholder="Sorunuzu yazınız"
                    {...register("question", {
                      required: { value: true, message: "Soru giriniz" },
                      minLength: { value: 10, message: "Soru kısa" },
                    })}
                    onChange={(e) => setQuestion(e.target.value)}
                  ></textarea>
                  <label htmlFor="question">
                    {errors.question && (
                      <div className="qna-form-errorText qna-form-error">
                        {errors.question.message}
                      </div>
                    )}
                  </label>
                </div>
              </div>
              <p className="fs-75 txtright w100p">
                {maxReachedAlert ? (
                  <span className="red-col">
                    En çok 1000 karakter yazabilirsiniz.
                  </span>
                ) : (
                  <span className={remainingSpace > 50 ? "green" : "red-col"}>
                    {remainingSpace}
                  </span>
                )}
              </p>
              <div
                className={
                  !errors.privacyTerms
                    ? "qna-form-row-divs"
                    : "qna-form-row-divs qna-form-alert-background"
                }
              >
                <input
                  className="qna-form-checkbox"
                  type="checkbox"
                  name="privacyTerms"
                  id="privacyTerms"
                  {...register("privacyTerms", {
                    required: { value: true, message: "Lütfen onaylayınız" },
                  })}
                />
                <label className="qna-form-checkbox-label">
                  <p>
                    <span
                      className="linkblue pointer"
                      onClick={() => setPrivacyTerms(true)}
                    >
                      Gizlilik sözleşmesini
                    </span>{" "}
                    okudum, onaylıyorum.
                  </p>
                </label>
                {errors.privacyTerms && (
                  <div className="qna-form-errorText qna-form-error">
                    {errors.privacyTerms.message}
                  </div>
                )}
              </div>
              <button
                className="create-button-active"
                type="submit"
                disabled={success ? true : false}
              >
                Gönder
              </button>
            </>
          )}
          {loading ? (
            <LoadingBoxWithoutText />
          ) : error ? (
            <MessageBox variant="danger">
              <h2 className="h2c">{error}</h2>
            </MessageBox>
          ) : (
            success && (
              <MessageBox variant="success">
                <h2 className="h2c">
                  Sorunuz başarı ile alındı. Yanıtlandığında beddo™ ekibinden
                  bir SMS bildirimi alacaksınız. Teşekkür ederiz.
                </h2>
              </MessageBox>
            )
          )}
        </form>
      ) : (
        <div className="qna-privacy-div">
          <QnaPrivacy
            authenticatedUser={authenticatedUser}
            name={name}
            phone={phone}
          />
        </div>
      )}
    </>
  );
}
